// @flow
/** @jsx jsx */

import Hoverable from '@zapier/common-components/src/components/Hoverable';
import Icon from '@zapier/common-components/src/components/Icon';
import Popover from '@zapier/common-components/src/components/Popover';
import TextInputWithComponent from '@zapier/common-components/src/components/TextInputWithComponent';
import { copyTextToClipboard } from '@zapier/common-utils';
import { jsx } from '@emotion/core';
import { Colors, Duration } from '@zapier/theme';

import type { TextInputProps } from '@zapier/common-components/src/components/TextInput';

const getButtonCss = ({ height }) => ({
  alignItems: 'center',
  background: Colors.storm,
  border: 'none',
  borderRadius: 0,
  cursor: 'pointer',
  display: 'flex',
  height: height || 41,
  justifyContent: 'center',
  lineHeight: 'normal', // FIXME: FLX-71 - needed to match web & web-ssr line-heights 💩
  margin: 0, // Safari applies 2px margin to buttons this clears it,
  outline: 'none',
  padding: '0 12px',
  transition: `background ${Duration.short} ease-in-out`,

  '&:hover:not([disabled]), &:focus:not([disabled])': {
    background: Colors.adamantium,
  },

  '&:active, &:focus:not([disabled]), &:hover:not([disabled]), &[disabled]': {
    backgroundImage: 'none', // FIXME: FLX-71 - needed to override global zapier/zapier styles 💩
  },
});

type Props = {
  ...$Exact<TextInputProps>,
  height?: number,
};

const CopyField = (props: Props) => {
  return (
    <TextInputWithComponent isReadonly={true} {...props}>
      <Hoverable>
        {({ isHovered }) => (
          <Popover
            content={<div>Copy to Clipboard</div>}
            show={isHovered}
            theme="dark"
          >
            <button
              aria-label="Copy to Clipboard"
              css={getButtonCss(props)}
              onClick={() => copyTextToClipboard(props.value || '')}
            >
              <Icon color="batmobile" name="clipboard" />
            </button>
          </Popover>
        )}
      </Hoverable>
    </TextInputWithComponent>
  );
};

export default CopyField;
